import Icon from "./Icon";

export default function AudioUpload({ uploadedAudio, fileInputRef, handleAudioUpload, handleClearUploadedAudio, disabled }) {
  return <>
    <button type="button" className="voice-text-button" onClick={() => fileInputRef.current?.click()} disabled={disabled}><Icon name="upload" />Upload audio</button>
    <input id="audio-upload" className="voice-file-input" type="file" accept="audio/*" aria-label="Upload Audio File" onChange={handleAudioUpload} ref={fileInputRef} disabled={disabled} />
    {uploadedAudio && <button type="button" className="voice-text-button" onClick={handleClearUploadedAudio} disabled={disabled} aria-label="Remove uploaded audio"><Icon name="close" />Remove</button>}
  </>;
}
